<template>
    <!-- Footer -->
    <footer>
        <div class="container">
            <div class="footer-top-row">
                <div class="mr-auto">
                    <ul class="nav link-black">
                        <li class="nav-item">
                            <router-link :to="{name: 'Help'}" class="nav-link" :alt="$t('public.footer.main_menu.faq')" :title="$t('public.footer.main_menu.faq')">{{$t("public.footer.main_menu.faq")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 'About'}" class="nav-link" :alt="$t('public.footer.main_menu.about')" :title="$t('public.footer.main_menu.about')">{{$t("public.footer.main_menu.about")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 'Partnerial'}" class="nav-link" :alt="$t('public.footer.main_menu.partners')" :title="$t('public.footer.main_menu.partners')">{{$t("public.footer.main_menu.partners")}}</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{name: 'Blog'}" class="nav-link" :alt="$t('public.footer.main_menu.blog')" :title="$t('public.footer.main_menu.blog')">{{$t("public.footer.main_menu.blog")}}</router-link>
                        </li>
                    </ul>
                </div>
                <div class="ml-auto">
                    <ul class="nav link-grey link-social">
                        <li class="nav-item">
                            <a class="nav-link" href="https://www.facebook.com/boxitilt/" target="_blank"><i class="icon-facebook-sign" alt="facebook.com" title="facebook.com"></i></a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="https://www.instagram.com/boxitilt/" target="_blank"><i class="icon-instagram" alt="instagram.com" title="instagram.com"></i></a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="https://www.linkedin.com/company/uab-boxiti" target="_blank"><i class="icon-linkedin-sign" alt="linkedin.com" title="linkedin.com"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="footer-middel-row">
                <div class="mr-auto">
                    <div class="lang-select">
                        <b-dropdown variant="link">
                            <div slot="button-content" :class="$i18n.locale" class="flag"></div>
                            <b-dropdown-item
                                v-for="item in langs"
                                v-if="item.value != $i18n.locale"
                                :key="item.label"
                                :href="item.domain"
                            >
                                <span :class="item.value" class="flag">{{ item.label }}</span>
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <ul class="nav link-grey">
                        <li class="nav-item">
                            <router-link tag="a" class="nav-link" :to="{name:'FriendlyThingsPage'}" v-html="$t('public.footer.second_menu.prohibited')" :alt="$t('public.footer.second_menu.prohibited')" :title="$t('public.footer.second_menu.prohibited')"></router-link>
                        </li>
                        <li class="nav-item">
                            <router-link tag="a" class="nav-link" :to="{name:'PrivacyPolicyPage'}" v-html="$t('public.footer.second_menu.privacy_policy')" :alt="$t('public.footer.second_menu.privacy_policy')" :title="$t('public.footer.second_menu.privacy_policy')"></router-link>
                        </li>
                        <li class="nav-item">
                            <span class="nav-link">
                                <router-link tag="a" :to="{name:'TermsAndConditionsPage'}" :alt="$t('public.footer.second_menu.delivery.text')" :title="$t('public.footer.second_menu.delivery.text')">{{$t('public.footer.second_menu.delivery.text')}}</router-link>
                                <span v-html="$t('public.footer.second_menu.delivery.link')"></span>
                            </span>
                        </li>
                        <li class="nav-item">
                            <span class="nav-link">
                                <router-link tag="a" :to="{name:'ProgrammablePage'}" :alt="$t('public.footer.second_menu.tracking.text')" :title="$t('public.footer.second_menu.tracking.text')">{{$t('public.footer.second_menu.tracking.text')}}</router-link>
                                <span v-html="$t('public.footer.second_menu.tracking.link')"></span>
                            </span>
                        </li>
                    </ul>
                </div>
                <div class="ml-auto">
                    <ul class="nav link-grey">
                        <li class="nav-item">
                            <a class="nav-link active" href="https://www.siuskpigiau.lt" target="_blank" v-if="$i18n.locale === 'lt'">
                                <img src="~img/brand_nav_link1.png" alt="siuskpigiau.lt" title="siuskpigiau.lt">
                            </a>
                            <a class="nav-link active" href="https://www.sendparcel.com/" target="_blank" v-else>
                                <img src="~img/brand_nav_link3.png" alt="sendparcel.com" title="sendparcel.com">
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="https://www.siuntupaieska.lt" target="_blank">
                                <img src="~img/brand_nav_link2.png" alt="siuntupaieska.lt" title="siuntupaieska.lt">
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="bg-black">
            <div class="container">
                <div class="footer-bottom-row">
                    <div class="mr-auto" v-html="'ALL RIGHTS RESERVED © 2019-2020 BOXITI'"></div>
                    <div class="ml-auto" v-html="'UAB Boxiti / Company code 304835940'"></div>
                </div>
            </div>
        </div>
    </footer>
    <!-- End Footer -->
</template>
<script>
    export default {
        name: 'footer-component',

        data() {
            return {
                // TODO: get lang list from server
                langs: [
                    {
                        label: 'LT',
                        value: 'lt',
                        domain: `${process.env.LT_DOMAIN}`
                    },
                    {
                        label: 'EN',
                        value: 'en',
                        domain: `${process.env.EN_DOMAIN}`
                    }
                ],
            }
        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/components/FooterComponent.vue